'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createFlexContainer = require('./helpers/createFlexContainer');

var _createFlexContainer2 = _interopRequireDefault(_createFlexContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultColumnStyle = { flexDirection: 'column' };

exports.default = (0, _createFlexContainer2.default)(defaultColumnStyle, 'Column');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@dhis2/d2-ui-core/layout/Column.component.js
// module id = 1898
// module chunks = 0